/**
 *
 * Asynchronously loads the component for FPL Home page
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { PageLoading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "FPLHome" */),
  loading: <PageLoading />
})
